package songwritersnotebook.app.di

import app.cash.sqldelight.db.SqlDriver
import songwritersnotebook.database.AppDatabase
import songwritersnotebook.app.database.DatabaseDriverFactory
import songwritersnotebook.app.database.SongRepository

class DatabaseModule(
    private val databaseDriverFactory: DatabaseDriverFactory,
    private val platformDependencyProvider: PlatformDependencyProvider
) {
    private var driver: SqlDriver? = null
    var database: AppDatabase? = null
        private set
    var songRepository: SongRepository? = null
        private set
    var chordLibraryRepository: songwritersnotebook.app.database.ChordLibraryRepository? = null
        private set

    suspend fun initialize() {
        if (database != null) return
        
        val newDriver = databaseDriverFactory.createDriver()
        driver = newDriver
        val newDatabase = AppDatabase(newDriver)
        database = newDatabase
        songRepository = SongRepository(newDatabase, platformDependencyProvider)
        chordLibraryRepository = songwritersnotebook.app.database.ChordLibraryRepository()
    }
    
    fun close() {
        driver?.close()
    }
}
